import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

export function Upload({ label, value, onChange, priv = false, testId }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post(`/upload?private=${priv}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Imagen subida");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" data-testid={testId} onClick={() => ref.current?.click()}
      className="w-full neon-card border-dashed p-3 flex items-center gap-3 text-left hover:border-primary/60 transition-colors">
      {value ? <img src={fileUrl(value, priv)} alt="" className="h-14 w-14 rounded-lg object-cover" /> :
        <div className="h-14 w-14 rounded-lg bg-secondary flex items-center justify-center text-muted-foreground">{busy ? <Loader2 className="animate-spin" /> : <ImagePlus />}</div>}
      <div className="text-sm"><div className="font-semibold">{label}</div><div className="text-muted-foreground text-xs">{value ? "Toca para cambiar" : "Toca para subir foto (jpg, png)"}</div></div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} />
    </button>
  );
}
